module.exports = __webpack_public_path__ + "img/message-smile.81f46ada.svg";